import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, AfterViewInit, HostListener, ChangeDetectionStrategy, inject, ChangeDetectorRef, computed } from '@angular/core';
import { ActionType, BookmarkComponent, BookmarksStore, UnsubscriberClass } from '@aston/foundation';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import * as RoutesDefinitions from 'apps/middle/src/app/routes-definitions';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { Location, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IAction } from '@aston/foundation';

import { injectFeaturesStore } from '../../../factor-features-module/stores/factor-features';
import { DashboardRoutesService } from '../../../shared-module/services';
import { IUser } from '../../../authentication-module/models';
import { BrandingPipe } from '../../pipes';

@Component({
	 
	selector: '[layout-menu]',
	templateUrl: './menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgOptimizedImage, BrandingPipe, TranslateModule, RouterLink, RouterLinkActive, BookmarkComponent]
})
export class MenuComponent extends UnsubscriberClass implements OnInit, AfterViewInit {

	protected bookmarksStore = inject(BookmarksStore)
	protected hrs = inject(DashboardRoutesService)
	protected cd = inject(ChangeDetectorRef)
	protected location = inject(Location)
	protected router = inject(Router)
	store = injectFeaturesStore()

	withDebtorPortal = injectFeaturesStore().debtorPortalClipIsEnabled;
	isImportMenuDisabled = computed(() => this.store.isImportMenuDisabled());
	isSpecificReportsEnabled = computed(() => this.store.bespokeReports().extraMenuDisplayed);
	isInterestPenaltiesMenuEnabled = computed(() => this.store.isInterestPenaltyEnabled());

	routes = {
		homePage:									RoutesDefinitions.getHomeFullPath(),
		overviewPage:								RoutesDefinitions.getOverviewFullPath(),
		opOverviewPage:								RoutesDefinitions.getOverviewFullPath(RoutesDefinitions.DashboardsPageOperationalRoutePath),
		fiOverviewPage:								RoutesDefinitions.getOverviewFullPath(RoutesDefinitions.DashboardsPageFinancialRoutePath),
		yoyDashboardPage:							RoutesDefinitions.getYoyDashboardFullPath(),
		teamDashboardPage:							RoutesDefinitions.getTeamDashboardRoutePathFullPath(),
		superDebtorsList: 							RoutesDefinitions.getSuperDebtorsListFullPath(),
		superDebtorContactsList: 					RoutesDefinitions.getSuperDebtorContactsListFullPath(),
		superDebtorRequestsList: 					RoutesDefinitions.getSuperDebtorsRequestsListFullPath(),
		accountingList: 							RoutesDefinitions.getAccountingListFullPath(),
		accountingImportsList: 						RoutesDefinitions.getAccountingImportsListFullPath(),
		accountingLettering: 						RoutesDefinitions.getAccountingLetteringFullPath(),
		paymentOrdersList: 							RoutesDefinitions.getPaymentOrdersListRouteFullPath(),
		dunning: 									RoutesDefinitions.getDunningRouteFullPath(),
		dunningCasesList: 							RoutesDefinitions.getDunningCasesListRouteFullPath(),
		dunningGroupsList: 							RoutesDefinitions.getDunningGroupsListRouteFullPath(),
		dunningContactsList: 						RoutesDefinitions.getDunningContactsListRouteFullPath(),
		dunningTemplatesList: 						RoutesDefinitions.getDunningTemplatesListRouteFullPath(),
		dunningScenariosList: 						RoutesDefinitions.getDunningScenariosListRouteFullPath(),
		intPenaltiesList: 							RoutesDefinitions.getInterestPenaltiesProfilesListRouteFullPath(),
		dunningActionsList: 						RoutesDefinitions.getDunningActionsListRouteFullPath(),
		dunningShipmentHistory:						RoutesDefinitions.getDunningShipmentHistoryRouteFullPath(),
		importRoot: 								RoutesDefinitions.getImportRootFullPath(),
		importCreation: 							RoutesDefinitions.getImportCreationRouteFullPath(),
		importList: 						 		RoutesDefinitions.getImportListRouteFullPath(),
		importProvidersList: 						RoutesDefinitions.getImportProvidersListRouteFullPath(),
		adminToolsPage: 							RoutesDefinitions.getAdminToolsPageRouteFullPath(),
		adminToolsOptionsPage: 						RoutesDefinitions.getAdminToolsOptionsRouteFullPath(),
		adminToolsTransfers: 						RoutesDefinitions.getAdminToolsTransfersRouteFullPath(),
		adminToolsSuperDebtorDunning: 				RoutesDefinitions.getAdminToolsSuperDebtorDunningRouteFullPath(),
		adminToolsIndicators:						RoutesDefinitions.getAdminToolsIndicatorsFullPath(),
		adminToolsClaimTypes:						RoutesDefinitions.getAdminToolsClaimTypesFullPath(),
		adminToolsWorkers: 							RoutesDefinitions.getAdminToolsWorkersRouteFullPath(),
		adminToolsWorkflowSchedulingInstancesList:	RoutesDefinitions.getAdminToolsWorkflowSchedulingInstancesListRouteFullPath(),
		adminToolsWorkflowSchedulingConfig: 		RoutesDefinitions.getAdminToolsWorkflowSchedulingConfigRouteFullPath(),
		adminToolsWorkflowSchedulingLauncher: 		RoutesDefinitions.getAdminToolsWorkflowSchedulingLauncherRouteFullPath(),
		adminToolsExtradataConfig:					RoutesDefinitions.getAdminToolsExtradataConfigFullPath(),
		adminToolsPortfolioRights:					RoutesDefinitions.getAdminToolsPortfolioRightsFullPath(),
		adminToolsUserReports:						RoutesDefinitions.getAdminToolsUserReportsFullPath(),
		adminToolsSpecificUserReports:				RoutesDefinitions.getAdminToolsSpecificUserReportsFullPath(),
		adminToolsUsers:							RoutesDefinitions.getAdminToolsUsersFullPath(),

		mobileHomePage:								RoutesDefinitions.getMobileHomeFullPath(),
		mobileSuperDebtorsList:						RoutesDefinitions.getMobileSuperDebtorsListFullPath(),
		mobileNotificationsList:					RoutesDefinitions.getMobileNotificationsListFullPath(),

	};

	@Output() action = new EventEmitter<IAction>();
	@Input() hasManualImportClearanceLevel: boolean;
	@Input() hasImportHistoryClearanceLevel: boolean;
	@Input() hasLetteringClearanceLevel: boolean;
	@Input() hasPaymentOrderClearanceLevel: boolean;
	@Input() hasAdministrationToolsClearanceLevel: boolean;
	@Input() hasSuperAdministrationClearanceLevel: boolean;
	@Input() hasTeamFollowUpClearanceLevel: boolean;
	@Input() hasReadOnlyAccessToAllSuperDebtorsClearanceLevel: boolean;
	@Input() hasDunningClearanceLevel: boolean;
	@Input() currentUser: IUser;

	@ViewChild('menulinks') menu: ElementRef<any>;

	ngOnInit() {
		if (this.hasSuperAdministrationClearanceLevel && !this.hasAdministrationToolsClearanceLevel) {
			this.routes.adminToolsPage = this.routes.adminToolsWorkers;
		}
	}

	ngAfterViewInit() {
		// This can be used to sync expanded menu with the navigation
		// In this case, the HostListener should be removed.
		// this.syncExpandedMenuWithNavigation();

		// This can be used to expand the menu of the first page only
		this.syncExpandedMenuWithCurrentPage();
		this.location.onUrlChange(_ => this.syncExpandedMenuWithCurrentPage())
	}

	syncExpandedMenuWithCurrentPage() {
		let link = null;
		let path = this.router.url
		do {
			link = this.menu.nativeElement.querySelector(`a[href*="${path}"]`);
			path = link ? path : path.split('/').slice(0, -1).join('/')
		} while (!link && path.split('/').length > 1)

		console.debug('[menu] sync menu from url %o: %o', path, link);
		this.collapseOtherMenus(link);
		this.cd.markForCheck();
	}

	syncExpandedMenuWithNavigation() {
		this.router.events.pipe(
			filter(e => e instanceof NavigationEnd),
			map(e => (e as NavigationEnd).urlAfterRedirects),
			startWith(this.router.url),
			takeUntil(this.destroySubscriptions$)
		).subscribe(url => {
			const link = this.menu.nativeElement.querySelector(`a[href~="${url}"]`);
			console.debug('[menu] sync menu from url %o: %o', url, link);
			this.collapseOtherMenus(link);
		})
	}

	@HostListener('click', ['$event.target'])
	collapseOtherMenus(btn: EventTarget) {
		const el = btn as HTMLDivElement;
		const hasMenuIcon = (el?: Element): boolean => el?.classList.contains('menu-icon')
		const fromTitle = el && (hasMenuIcon(el.previousElementSibling) || hasMenuIcon(el.firstElementChild));

		let newParent = el;
		while (el && newParent && !(newParent.parentNode as HTMLDivElement)?.classList?.contains('menu-links')) {
			newParent = newParent.parentNode as HTMLDivElement;
		}

		[...this.menu.nativeElement.children]
			.forEach(e => e.classList.add('menu-collapsed'));

		if (newParent) {
			if (fromTitle)
				newParent.classList.toggle('menu-collapsed');
			else
				newParent.classList.remove('menu-collapsed');
		}
	}

	onToggle() {
		this.action.emit({ type: ActionType.TOGGLE });
	}

	onDunningActionForm(url: string) {
		return !!(url.includes(this.routes.dunning) && url.match(/(doActionId|showActionId)/))
	}

	specialActiveCases(path: string): boolean {
		return (path === this.routes.superDebtorsList 
			&& this.router.url.includes(this.routes.superDebtorsList)
			&& !this.router.url.includes(this.routes.superDebtorContactsList)
			&& !this.router.url.includes(this.routes.superDebtorRequestsList)
			&& !this.onDunningActionForm(this.router.url))
			|| (path === this.routes.dunning && (
				this.router.url.includes(this.routes.dunningActionsList)
				|| this.router.url.includes(this.routes.dunningCasesList)
				|| this.router.url.includes(RoutesDefinitions.DunningSettingRoutePath)
				|| this.onDunningActionForm(this.router.url)))
		;
	}
}
